import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle px-4 md:px-6 lg:px-8" };
const _hoisted_3 = { class: "flex justify-between items-center mb-2" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg" }, "Kronos Regions", -1);
const _hoisted_5 = { class: "my-2" };
const _hoisted_6 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_8 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline" };
const _hoisted_11 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
const _hoisted_12 = {
    key: 0,
    class: "text-lg text-center text-gray-600 mt-4"
};
const _hoisted_13 = { class: "flex justify-between items-center mb-2 mt-10" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg" }, "Kronos Codes", -1);
const _hoisted_15 = { class: "my-2" };
const _hoisted_16 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_18 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline" };
const _hoisted_21 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
const _hoisted_22 = {
    key: 1,
    class: "text-lg text-center text-gray-600 mt-4"
};
const _hoisted_23 = { class: "flex justify-between items-center mb-2 mt-10" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg" }, "Kronos Licenses", -1);
const _hoisted_25 = { class: "my-2" };
const _hoisted_26 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_27 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_28 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline" };
const _hoisted_31 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
const _hoisted_32 = {
    key: 2,
    class: "text-lg text-center text-gray-600 mt-4"
};
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'KronosManagement',
    props: {
        kronos: { default: () => [] },
        kronosCodes: { default: () => [] },
        kronosLicenses: { default: () => [] }
    },
    emits: ["openModal"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const regionsList = computed(() => {
            const k = props.kronos;
            return Array.isArray(k) ? k : [];
        });
        const codesList = computed(() => {
            const k = props.kronosCodes;
            return Array.isArray(k) ? k : [];
        });
        const licensesList = computed(() => {
            const k = props.kronosLicenses;
            return Array.isArray(k) ? k : [];
        });
        const handleClickRegion = (region) => {
            emit('openModal', { formType: 'kronosRegion', configData: region });
        };
        const handleClickCode = (code) => {
            emit('openModal', { formType: 'kronosCode', configData: code });
        };
        const handleClickLicense = (license) => {
            emit('openModal', { formType: 'kronosLicense', configData: license });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('openModal', { formType: 'kronosRegion' })), ["prevent"]))
                            }, "\n            Add Region\n          ")
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("table", _hoisted_7, [
                            _createElementVNode("tbody", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionsList.value, (region) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: region.ID,
                                        class: "cursor-pointer",
                                        onClick: _withModifiers(($event) => (handleClickRegion(region)), ["prevent"])
                                    }, [
                                        _createElementVNode("td", _hoisted_10, [
                                            _createTextVNode(_toDisplayString(region.Label || region.ID) + " ", 1),
                                            (!region.LKStatus)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\n                  Inactive\n                "))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_9));
                                }), 128))
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (!regionsList.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "\n        No Kronos regions. Click \"Add Region\" to create one.\n      "))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (emit('openModal', { formType: 'kronosCode' })), ["prevent"]))
                            }, "\n            Add Code\n          ")
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("table", _hoisted_17, [
                            _createElementVNode("tbody", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codesList.value, (code) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: code.ID,
                                        class: "cursor-pointer",
                                        onClick: _withModifiers(($event) => (handleClickCode(code)), ["prevent"])
                                    }, [
                                        _createElementVNode("td", _hoisted_20, [
                                            _createTextVNode(_toDisplayString(code.ID) + " ", 1),
                                            (!code.LKStatus)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "\n                  Inactive\n                "))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_19));
                                }), 128))
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (!codesList.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, "\n        No Kronos codes. Click \"Add Code\" to create one.\n      "))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (emit('openModal', { formType: 'kronosLicense' })), ["prevent"]))
                            }, "\n            Add License\n          ")
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("table", _hoisted_27, [
                            _createElementVNode("tbody", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(licensesList.value, (license) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: license.ID,
                                        class: "cursor-pointer",
                                        onClick: _withModifiers(($event) => (handleClickLicense(license)), ["prevent"])
                                    }, [
                                        _createElementVNode("td", _hoisted_30, [
                                            _createTextVNode(_toDisplayString(license.Label || license.ID) + " ", 1),
                                            (!license.LKStatus)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "\n                  Inactive\n                "))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_29));
                                }), 128))
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (!licensesList.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, "\n        No Kronos licenses. Click \"Add License\" to create one.\n      "))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
